/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_CONNECTION_NAME_REQUIRED, ERR_EMAIL, ERR_EMAIL_INVALID, LABEL_BTN_CANCEL, LABEL_BTN_SAVE, UNKNOWN_ERR } from 'src/constants/constant';
import { TextField, Typography, Divider, Autocomplete } from '@mui/material';
import type {RootState, ESPFormInputs } from '../../types/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import OutlineButton from '../../MUICustomButton/OutlineButton';
import GradientButton from '../../MUICustomButton/GradientButton';
import { useNavigate } from 'react-router-dom';
import {checkEventPermission} from "../../../common/utility/utility";
import { getESPConnectionData,addESPData } from '../../../services/emailAPIESPServices';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';

const urlRegx = /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm;

const validationSchema = Yup.object().shape({
    connectionName: Yup.string().required(ERR_CONNECTION_NAME_REQUIRED).matches(/^\S.*\S$|^\S$/, "Please enter a valid connection name"),
    connectionTypeId: Yup.number().required("Please select email service provider"),
    domain: Yup.string().required("Please enter the domain name")
        .matches(
            /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/,
            "Enter a valid domain name"
        ),
    viewEmailDomainURL: Yup.string().required("Please enter view in browser URL")
    .matches(
        urlRegx,
        "Enter a valid URL"
    ),
    fromName: Yup.string().required("Please enter the from name").matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, "Please enter a valid from name"),
    fromEmail: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        )
        .test(
            'matches-domain',
            "Email domain must match the provided domain",
            function (value) {
                if (!value) return true; // Skip validation if empty (already handled by required)
                const emailDomain = value.split('@')[1];
                return emailDomain === this.parent.domain; // Compare with domain field
            }
        ),
    replyToEmail: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),

    dailyCount: Yup.number().typeError("Only numbers are allowed")
        .integer("Only whole numbers are allowed")
        .test(
            "is-strict-integer",
            "Only whole numbers are allowed",
            (value, context) => {
              return /^\d+$/.test(context.originalValue); // Ensures no decimals or just "."
            }
        )
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .required("Please enter daily count"),
    
    hourlyCount: Yup.number().typeError("Only numbers are allowed")
        .integer("Only whole numbers are allowed")
        .test(
            "is-strict-integer",
            "Only whole numbers are allowed",
            (value, context) => {
              return /^\d+$/.test(context.originalValue); // Ensures no decimals or just "."
            }
        )
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .required("Please enter hourly count"),
    
    hasWarmup: Yup.boolean().required("Please select warmup"),
    
    warmupStartCount: Yup.number()
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only whole numbers are allowed")
                .integer("Only whole numbers are allowed")
                .test(
                    "is-strict-integer",
                    "Only whole numbers are allowed",
                    (value, context) => value !== undefined && /^\d+$/.test(context.originalValue)
                )
                .min(1, "Must be at least 1")
                .max(1000000, "Value cannot exceed 10 lakh")
                .required("Warmup start count is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    warmupTrackingDays: Yup.number()
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only whole numbers are allowed")
                .integer("Only whole numbers are allowed")
                .test(
                    "is-strict-integer",
                    "Only whole numbers are allowed",
                    (value, context) => value !== undefined && /^\d+$/.test(context.originalValue)
                )
                .min(1, "Must be at least 1")
                .max(365, "Must not exceed 365")
                .required("Warmup Tracking Days is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    warmupMultiplier: Yup.number()
        .when("hasWarmup", {
            is: true,
            then: (schema) => schema
                .typeError("Only decimal values are allowed")
                .moreThan(0, "Must be greater than 0")
                .max(9999999.9999999, "Value cannot exceed 9,999,999.9999999")
                .test("is-decimal", "Only decimal values are allowed", (value) => value !== undefined && !Number.isInteger(value))
                .required("Warmup multiplier is required"),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),

    asmGroupId: Yup.number()
        .transform((value, originalValue) => {
            // Handle empty strings cleanly (treat as undefined)
            if (typeof originalValue === 'string') {
            const trimmed = originalValue.trim();
            if (trimmed === '') return undefined;
            if (/^\d+$/.test(trimmed)) return Number(trimmed);
            }
            return originalValue;
        })
        .typeError("Only whole numbers are allowed")
        .integer("Only whole numbers are allowed")
        .min(1, "Value must be greater than 0")
        .max(1000000, "Value cannot exceed 10 lakh")
        .when('connectionTypeId', {
            is: (val: number) => val !== 1,
            then: (schema) => schema.required("Please enter ASM Group ID"),
            otherwise: (schema) => schema.notRequired().nullable()
        }),
    espAccountKey: Yup.string().required("ESP Account Key is required").matches(/^\S.*\S$|^\S$/, "Please enter a valid ESP account key"),    
});

export interface PropsType {
    parentId?: string;
}

function AddESPForm({ parentId }: PropsType): JSX.Element {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm<ESPFormInputs>({
        resolver: yupResolver(validationSchema),
    });

    const hasWarmup = watch("hasWarmup");
    useEffect(() => {
        console.log("hasWarmup changed:", hasWarmup);
    }, [hasWarmup]);

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])

    const onSubmit = async (data: ESPFormInputs): Promise<void> => {
        setIsLoading(true)

        const requestParams = {
            "connectionTypeId": data.connectionTypeId,
            "domain": data.domain,
            "fromEmail": data.fromEmail,
            "fromName": data.fromName,
            "dailyCount": data.dailyCount,
            "hourlyCount": data.hourlyCount,
            "createdBy": user?.id,
            "nextDeliveryTime": new Date().toISOString(),
            "warmupStartCount": data.warmupStartCount,
            "warmupMultiplier": data.warmupMultiplier,
            "warmupTrackingDays": data.warmupTrackingDays,
            "hasWarmup": data.hasWarmup,
            "connectionName": data.connectionName,
            "espAccountKey": data.espAccountKey,
            "asmGroupId": data.asmGroupId,
            "viewEmailDomainURL": data.viewEmailDomainURL,
            "replyToEmail": data.replyToEmail,
        }

        try {
            const res = await addESPData(requestParams);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success("ESP created successfully");
                    setTimeout(() => {
                        if (parentId === undefined) {
                            handleBackClick()
                        } else {

                            navigate(-1)
                        }

                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    NotificationManager.error(errorMsg.includes('A ConnectionName already exists') ? 'Connection name already exists' : UNKNOWN_ERR, '', 5000);
                }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
    }

    const handleBackClick = (): void => {
        navigate('/email-api')
    }

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
                ESP Settings
            </Typography>
            <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        ESP Configuration
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="connectionName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Connection Name*"
                                                autoComplete="off"
                                                placeholder="Connection Name*"
                                                error={Boolean(errors.connectionName)}
                                            />
                                            {errors.connectionName && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.connectionName.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">
                            <div className="mb-[30px] relative">
                                <Controller
                                    name="domain"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Domain Name*"
                                                autoComplete="off"
                                                placeholder="Domain Name*"
                                                error={Boolean(errors.domain)}
                                            />
                                            {errors.domain && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.domain.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div> 
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="connectionTypeId"
                                    control={control}
                                    rules={{ required: "Please select an email service provider" }} // Ensure validation
                                    render={({ field }) => (
                                        <div>
                                            <Autocomplete
                                                options={[
                                                    { label: "Mailgun", value: 1 },
                                                    { label: "Sendgrid", value: 2 },
                                                ]}
                                                getOptionLabel={(option) => option.label}
                                                isOptionEqualToValue={(option, value) => option.value === (value as any)?.value}
                                                popupIcon={
                                                  <HugeiconsIcon
                                                    icon={ArrowDown01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                
                                                  />
                                                }
                                                onChange={(_, selectedOption) => {
                                                    field.onChange(selectedOption?.value ?? null); // Ensure valid value or null
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Email Service Provider*"
                                                        placeholder="Select Email Service Provider"
                                                        error={Boolean(errors.connectionTypeId)}
                                                    />
                                                )}
                                                disableClearable
                                            />
                                            {errors.connectionTypeId && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.connectionTypeId.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">
                            <div className="mb-[30px] relative">
                                <Controller
                                    name="viewEmailDomainURL"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="View in Browser URL*"
                                                autoComplete="off"
                                                placeholder="View in Browser URL*"
                                                error={Boolean(errors.viewEmailDomainURL)}
                                            />
                                            {errors.viewEmailDomainURL && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.viewEmailDomainURL.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="fromName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="From Name*"
                                                autoComplete="off"
                                                placeholder="From Name*"
                                                error={Boolean(errors.fromName)}
                                            />
                                            {errors.fromName && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.fromName.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">
                            <div className="mb-[30px]">
                                <Controller
                                    name="fromEmail"
                                    defaultValue=""
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="From Email Address*"
                                                autoComplete="off"
                                                placeholder="From Email Address*"
                                                error={Boolean(errors.fromEmail)}
                                            />
                                            {errors.fromEmail && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.fromEmail.message}
                                                </div>
                                            )}
                                    </div>
                                )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className="w-full relative ">
                            <div className="mb-[30px]">
                                <Controller
                                    name="replyToEmail"
                                    defaultValue=""
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Reply to Email Address*"
                                                autoComplete="off"
                                                placeholder="Reply to Email Address*"
                                                error={Boolean(errors.replyToEmail)}
                                            />
                                            {errors.replyToEmail && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.replyToEmail.message}
                                                </div>
                                            )}
                                    </div>
                                )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        API Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="espAccountKey"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="ESP Account Key*"
                                                autoComplete="off"
                                                placeholder="ESP Account Key"
                                                error={Boolean(errors.espAccountKey)}
                                            />
                                            {errors.espAccountKey && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.espAccountKey.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="mb-[30px]">
                            <Controller
                                name="asmGroupId"
                                control={control}
                                render={({ field }) => (
                                    <div>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="ASM GroupId*"
                                            autoComplete="off"
                                            placeholder="ASM GroupId"
                                            error={Boolean(errors.asmGroupId)}
                                        />
                                        {errors.asmGroupId && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.asmGroupId.message}
                                            </div>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Throughput Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="dailyCount"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Daily Limit*"
                                                autoComplete="off"
                                                placeholder="Daily Limit"
                                                error={Boolean(errors.dailyCount)}
                                            />
                                            {errors.dailyCount && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.dailyCount.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="mb-[30px]">
                            <Controller
                                name="hourlyCount"
                                control={control}
                                render={({ field }) => (
                                    <div>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Hourly Limit*"
                                            autoComplete="off"
                                            placeholder="Hourly Limit"
                                            error={Boolean(errors.hourlyCount)}
                                        />
                                        {errors.hourlyCount && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                {errors.hourlyCount.message}
                                            </div>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Warmup Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="hasWarmup"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <Autocomplete
                                                options={[
                                                    { label: "Yes", value: true },
                                                    { label: "No", value: false },
                                                ]}
                                                getOptionLabel={(option) => option.label}
                                                isOptionEqualToValue={(option, value) => option.value === value?.value}
                                                popupIcon={
                                                  <HugeiconsIcon
                                                    icon={ArrowDown01Icon}
                                                    size={18}
                                                    color="#3A3A3A"
                                                    strokeWidth={0.2}
                                                
                                                  />
                                                }
                                                onChange={(_, selectedValue) => {
                                                    field.onChange(selectedValue?.value ?? false);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Warmup*"
                                                        placeholder="Warmup"
                                                        error={Boolean(errors.hasWarmup)}
                                                    />
                                                )}
                                                disableClearable
                                            />
                                            {errors.hasWarmup && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.hasWarmup.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="warmupMultiplier"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Warmup Multiplier"
                                                autoComplete="off"
                                                placeholder="Warmup Multiplier"
                                                error={Boolean(errors.warmupMultiplier)}
                                                disabled={!watch('hasWarmup')}
                                            />
                                            {errors.warmupMultiplier && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.warmupMultiplier.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="warmupTrackingDays"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Warmup Tracking Days"
                                                autoComplete="off"
                                                placeholder="Warmup Tracking Days"
                                                error={Boolean(errors.warmupTrackingDays)}
                                                disabled={!watch('hasWarmup')}
                                            />
                                            {errors.warmupTrackingDays && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.warmupTrackingDays.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="warmupStartCount"
                                    control={control}
                                    render={({ field }) => (
                                        <div>
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Warmup Start Count"
                                                autoComplete="off"
                                                placeholder="Warmup Start Count"
                                                error={Boolean(errors.warmupStartCount)}
                                                disabled={!watch('hasWarmup')}
                                            />
                                            {errors.warmupStartCount && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.warmupStartCount.message}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex gap-2 justify-end mt-[30px]'>
                    <OutlineButton color='gray' onClick={() => handleBackClick()} width='130px'>{LABEL_BTN_CANCEL}</OutlineButton>
                    <GradientButton type='submit' color='red' onClick={handleBackClick} width='130px' disabled={isLoading || !checkEventPermission("ESP_ADD")}>{!isLoading ? LABEL_BTN_SAVE : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                </div>
            </form>
        </React.Fragment>
    )
}

export default AddESPForm